import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { LoadingCommon, TabCommon } from 'src/common'
import {
	selectDefinitionEN,
	selectDefinitionVN,
	selectGetDefinitionLoading,
	selectMoreExamples,
	selectSpelling,
	selectTerm,
} from 'src/redux/definition/definition.selector'
import { DICT_LANGUAGE } from 'src/utils/constant'
import DefinitionContent from './components/DefinitionContent/DefinitionContent'
import ExampleContent from './components/ExampleContent/ExampleContent'
import FormEditWord from './components/FormEditWord/FormEditWord'
import './Dictionary.scss'

const DictionaryComponent = ({
	term,
	isLoading,
	definitionEN,
	definitionVN,
	moreExamples,
	editWord,
}) => {
	const tabContent = [
		{
			title: 'Tiếng Việt',
			keyTab: 1,
			component: (
				<DefinitionContent
					word={term}
					def={editWord === '' ? '' : definitionVN}
					isTermEmpty={!term}
					lang={DICT_LANGUAGE.VI}
				/>
			),
		},
		{
			title: 'English',
			keyTab: 2,
			component: (
				<DefinitionContent
					word={term}
					def={editWord === '' ? '' : definitionEN}
					isTermEmpty={!term}
					lang={DICT_LANGUAGE.EN}
				/>
			),
		},
		{
			title: 'More examples',
			keyTab: 3,
			component: (
				<ExampleContent
					word={term}
					// definitionUser={definition}
					// onAddToDefinition={onAddToDefinition}
					// onRemoveFromDefinition={onRemoveFromDefinition}
					isTermEmpty={!term}
					moreExamples={editWord === '' ? [] : moreExamples}
					// isProUser={isProUser}
					// onClick={openUpgradePopup}
				/>
			),
		},
	]

	return (
		<div className="suggest-definition-1669797081594">
			<h1 className="title u-h4">Dictionary</h1>
			<FormEditWord />
			<div className="list-definition">
				{isLoading ? (
					<LoadingCommon size="default" isLoading={isLoading} />
				) : (
					<TabCommon tabs={tabContent} />
				)}
			</div>
		</div>
	)
}

const mapStateToProps = createStructuredSelector({
	term: selectTerm,
	spelling: selectSpelling,
	definitionVN: selectDefinitionVN,
	definitionEN: selectDefinitionEN,
	moreExamples: selectMoreExamples,
	isLoading: selectGetDefinitionLoading,
})

// const mapDispatchToProps = {
// 	onGetDefinition,
// }

export const Dictionary = connect(mapStateToProps)(DictionaryComponent)
